// src/utils/printUtils.js
export const printContent = (htmlContent, styles = '') => {
    let printWindow = window.open('', '', 'height=400,width=750');
    printWindow.document.write(`<html><head><title>Print</title>`);
    printWindow.document.write('<link href="/iusevolutione/assets/vendor/css/rtl/core.css" rel="stylesheet" type="text/css" />');
    printWindow.document.write('<style>');
    printWindow.document.write(styles);
    printWindow.document.write('</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(htmlContent);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
  
    printWindow.onbeforeprint = function() {
      console.log("Print dialog opened");
    };
  
    printWindow.onafterprint = function() {
      if (printWindow) {
        printWindow.close();
        printWindow = null;
      }
    };
  
    printWindow.print();
  };
  